import React, { useState, useEffect } from 'react';
import MarkdownIt from 'markdown-it';
import markdownStyle from 'markdown-it-style';
import { useMediaQuery } from 'react-responsive';
import NoSSR from 'react-no-ssr';
import { CookieBanner as CookieBanner$1 } from '@palmabit/react-cookie-law';
import queryString from 'query-string';
import extractDomain from 'extract-domain';
import { Md5 } from 'ts-md5';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var md = /*#__PURE__*/new MarkdownIt({
  html: true
});
var h = "\n    font-weight: bold;\n    margin: 1.8em 0 1.47em 0;\n    padding-bottom: 0.33em;\n    line-height: 1.33;yarn\n    font-size: 2em;\n    border-bottom: 1px solid hsla(0,0%,50%,.33);\n";
md.use(markdownStyle, {
  h1: h + "font-size: 2em;",
  h2: h + "font-size: 1.5em;",
  h3: h + "font-size: 1.2em;",
  p: 'margin: 1.2em 0;',
  ul: "\n    list-style-type: disc;\n    padding-inline-start: 40px;\n  ",
  blockquote: "\n    color: rgba(0,0,0,.5);\n    padding-left: 1.5em;\n    border-left: 5px solid rgba(0,0,0,.1);\n  ",
  table: 'border-spacing: 0;',
  img: 'width: 100%'
});
var renderMarkdown = function renderMarkdown(markdown) {
  return md.render(markdown);
};
function Markdown(_ref) {
  var markdown = _ref.markdown,
    className = _ref.className;
  return React.createElement("div", {
    className: "markdown " + className,
    dangerouslySetInnerHTML: {
      __html: renderMarkdown(markdown)
    }
  });
}
Markdown.defaultProps = {
  className: ''
};
function MarkdownPath(_ref2) {
  var path = _ref2.path,
    className = _ref2.className;
  var _useState = useState(''),
    html = _useState[0],
    setHtml = _useState[1];
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response, markdown;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(path);
            case 2:
              response = _context.sent;
              _context.next = 5;
              return response.text();
            case 5:
              markdown = _context.sent;
              setHtml(md.render(markdown));
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [path]);
  return React.createElement("div", {
    className: "markdown " + (className || ''),
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
}
MarkdownPath.defaultProps = {
  className: {}
};

function Seo(_ref) {
  var title = _ref.title,
    description = _ref.description,
    imageUrl = _ref.imageUrl,
    pageUrl = _ref.pageUrl;
  var fixedDescription = description.length > 170 ? description.slice(0, 165) + "..." : description;
  return React.createElement(React.Fragment, null, React.createElement("meta", {
    name: 'description',
    content: fixedDescription
  }), React.createElement("meta", {
    property: 'og:title',
    content: title
  }), React.createElement("meta", {
    property: 'og:description',
    content: fixedDescription
  }), React.createElement("meta", {
    property: 'og:image',
    content: imageUrl
  }), React.createElement("meta", {
    property: 'og:url',
    content: pageUrl
  }), React.createElement("meta", {
    property: 'og:type',
    content: 'website'
  }), React.createElement("meta", {
    name: 'twitter:card',
    content: fixedDescription
  }), React.createElement("meta", {
    name: 'twitter:title',
    content: fixedDescription
  }), React.createElement("meta", {
    name: 'twitter:description',
    content: fixedDescription
  }), React.createElement("meta", {
    name: 'twitter:url',
    content: pageUrl
  }), React.createElement("meta", {
    property: 'twitter:image',
    content: imageUrl
  }), React.createElement("link", {
    rel: 'canonical',
    href: pageUrl
  }));
}

// Create a Title component that'll render an <h1> tag with some styles
var titleStyle = function titleStyle(mobile) {
  return {
    fontSize: mobile ? '0.8em' : '1em',
    textAlign: 'center',
    color: '#888888',
    padding: '5px',
    letterSpacing: '0.025em',
    fontWeight: 450
  };
};
// Create a Wrapper component that'll render a <section> tag with some styles
var wrapperStyle = {
  background: 'white',
  borderBottom: '1px solid #D5D5D5'
};
function AdsDisclaimer(_ref) {
  var text = _ref.text;
  var mobile = useMediaQuery({
    query: 'screen and (max-width: 650px)'
  });
  return React.createElement("section", {
    style: wrapperStyle
  }, React.createElement(NoSSR, null, React.createElement("h1", {
    style: titleStyle(mobile)
  }, text)));
}
AdsDisclaimer.defaultProps = {
  text: 'Some links in this article may be affiliate links. We\'re letting you know because it\'s the right thing to do.'
};

// Reference: https://ec.europa.eu/eurostat/statistics-explained/index.php?title=Glossary:European_Union_(EU)
var isEuOrGB = function isEuOrGB(countryIsoCode) {
  if (!countryIsoCode) return false;
  var EUorGBs = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'EL', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];
  return EUorGBs.includes(countryIsoCode.toUpperCase());
};
function CookieBanner(_ref) {
  var countryIsoCode = _ref.countryIsoCode;
  if (!isEuOrGB(countryIsoCode)) return null;
  return React.createElement(NoSSR, null, React.createElement(CookieBanner$1, {
    policyLink: '/privacy',
    message: 'This site or third-party tools used by this make use of cookies necessary for the operation and useful for the purposes outlined in the cookie policy. To learn more or opt out, see the cookie policy. By accepting, you consent to the use of cookies.',
    styles: {
      dialog: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100000,
        backgroundColor: 'rgb(248, 247, 247)',
        padding: '10px'
      },
      container: {
        maxWidth: '1140px',
        marginLeft: 'auto',
        marginRight: 'auto',
        overflow: 'hidden'
      },
      message: {
        minHeight: '32px',
        fontSize: '8pt',
        fontWeight: 400,
        lineHeight: '130%',
        padding: '10px 0px',
        color: 'rgb(0, 0, 0)'
      }
    },
    wholeDomain: true,
    onAccept: function onAccept() {},
    onAcceptPreferences: function onAcceptPreferences() {},
    onAcceptStatistics: function onAcceptStatistics() {},
    onAcceptMarketing: function onAcceptMarketing() {}
  }));
}

var CLICK_APP = 'https://clicks.growthhub.com';
var WIZARD_APP = 'https://wizard.growthhub.com';
var BUYERZONE_APP = 'https://app.buyerzone.com';

/**
 * Load javascript file dynamically
 * @param src
 */
var loadScript = function loadScript(src) {
  return new Promise(function (resolve) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    if (src) script.src = src;
    script.type = 'text/javascript';
    script.async = false;
    script.defer = false;
    script.onload = function () {
      console.log(src + " script is loaded!");
      resolve(script);
    };
    head.appendChild(script);
  });
};
/**
 * Execute divolte event as long as divolte is installed in the website.
 * @param payload
 */
var runDivolte = function runDivolte(payload) {
  var divolteTries = 0;
  var divolteCallback = function divolteCallback(first) {
    divolteTries += 1;
    setTimeout(function () {
      if (!window.divolte) {
        if (divolteTries > 10) {
          console.error('No divolte was found');
          return;
        }
        divolteCallback();
        return;
      }
      window.divolte.signal('ClickHappened', {
        actionType: payload.actionType,
        actionPayload: JSON.stringify(payload.actionPayload)
      });
    }, first ? 0 : 1000);
  };
  divolteCallback(true);
};

/**
 * This function adds a gh wizard. Also, it returns onmessage handler to accept events from its iframe.
 * @param options
 */
var addGhWizard = function addGhWizard(options) {
  var containerId = options.containerId;
  var random = Math.round(Math.random() * 10000000000000000);
  var container = document.getElementById(containerId);
  var originalStyle = {
    position: container.style.position,
    zIndex: container.style.zIndex,
    inset: container.style.inset,
    backgroundColor: container.style.backgroundColor,
    height: container.style.height
  };
  var wrapperWizardId = "gh-wrapper-" + containerId + "-" + random;
  var iframeWizardId = "gh-iframe-" + containerId + "-" + random;
  container.insertAdjacentHTML('beforeend', "<div id=\"" + wrapperWizardId + "\" style=\"height: 600px;\"><iframe\n    id=\"" + iframeWizardId + "\"\n    src=\"" + WIZARD_APP + "?options=" + encodeURIComponent(JSON.stringify(options)) + "\"\n    style=\"border: none; width: 100%; height: 100%;\"></iframe></div>");
  var wrapperWizard = document.getElementById(wrapperWizardId);
  return function (e) {
    var origin = e.origin,
      data = e.data;
    var payload = data || {};
    var action = payload.action,
      frameHeight = payload.frameHeight,
      fullScreenOpen = payload.fullScreenOpen;
    if (origin !== WIZARD_APP) return;
    switch (action) {
      case 'UPDATE_HEIGHT':
        // from gh-wizard
        wrapperWizard.style.height = (frameHeight || 600) + "px";
        break;
      case 'FULL_SCREEN_OPEN':
        // from gh-wizard
        if (fullScreenOpen) {
          container.style.backgroundColor = '#fff';
          container.style.position = 'fixed';
          container.style.zIndex = '1300';
          container.style.inset = '0px';
          container.style.height = '100%';
        } else {
          container.style.backgroundColor = originalStyle.backgroundColor;
          container.style.position = originalStyle.position;
          container.style.zIndex = originalStyle.zIndex;
          container.style.inset = originalStyle.inset;
          container.style.height = originalStyle.height;
        }
        break;
      case 'DIVOLTE_EVENT':
        // from gh-wizard
        runDivolte(payload);
        break;
    }
  };
};

var findClicksSize = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var name, url, response, _yield$response$json, size;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = _ref.name;
            _context.prev = 1;
            url = CLICK_APP + "/api/clicks-size?name=" + name;
            _context.next = 5;
            return fetch(url);
          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();
          case 8:
            _yield$response$json = _context.sent;
            size = _yield$response$json.size;
            return _context.abrupt("return", size);
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            if (_context.t0 instanceof Error) console.error('Failed to fetch /api/click-size', _context.t0);
            return _context.abrupt("return", 0);
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));
  return function findClicksSize(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * This class is used to display thank you page on buyerZone widget after submission of lead.
 * However, only dedicated slugs will have the thank you page.
 */
var ThankYou = /*#__PURE__*/function () {
  function ThankYou(options) {
    this.containerId = options.containerId;
    this.clickSlug = options.clickSlug;
    this.thankYou = options.thankYou;
    this.iframeId = options.iframeId;
    this.tracking = options.tracking;
  }
  var _proto = ThankYou.prototype;
  _proto.startEmbed = function startEmbed() {
    this.startB2BC();
    this.startClickList();
  };
  _proto.startB2BC = function startB2BC() {
    if (!this.clickSlug) {
      console.log('No thank you page for B2B or B2C! (No vertical)');
      return;
    }
    var ALLOWED_THANK_YOU_CLICK_SLUGS = ['business-loans', 'equipment-leasing', 'gps-fleet-tracking', 'factoring', 'hot-tubs', 'home-security', 'steel-buildings', 'residential-steel-buildings'];
    if (!ALLOWED_THANK_YOU_CLICK_SLUGS.includes(this.clickSlug)) return;
    this.attachB2BC();
  };
  _proto.attachB2BC = function attachB2BC() {
    var container = document.getElementById(this.containerId);
    if (!container) return;
    var thankYouPageUrl = CLICK_APP + "/thank-you/" + this.clickSlug + "?fcw=" + encodeURIComponent(window.location.href);
    container.innerHTML = "<iframe\n      id=\"" + this.iframeId + "\"\n      src=\"" + thankYouPageUrl + "\"\n      style=\"border: none; width: 100%; height: 600px; max-height: 1650px;\"></iframe>";
  };
  _proto.startClickList = function startClickList() {
    var _this = this;
    if (!this.thankYou) {
      console.log('No thank you page for click list!');
    }
    var name = this.thankYou;
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var size;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return findClicksSize({
                name: name
              });
            case 2:
              size = _context.sent;
              if (size > 0) {
                _this.attachClickList();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  };
  _proto.attachClickList = function attachClickList() {
    var container = document.getElementById(this.containerId);
    if (!container) return;
    container.innerHTML = "<div style=\"padding: 13px 19px;\"><iframe\n     id=\"" + this.iframeId + "\"\n     src=\"" + CLICK_APP + "/thank-you?name=" + this.thankYou + ("&fcw=" + encodeURIComponent(this.tracking.clientRoute) + "&referer=" + encodeURIComponent(this.tracking.referer) + "\"\n     style=\"border: none; width: 100%; height: 600px; max-height: 1650px;\"></iframe></div>");
  };
  return ThankYou;
}();

/**
 * This function adds a bz widget. Also, it returns onmessage handler to accept events from its iframe.
 * It accepts two events from buyerzone site and gh-clicks site.
 * A event from BZ comes when user completes the form. In this case, thank page should be added by calling gh-clicks sites.
 * A event from gh-clicks comes when thank you page height is updated.
 * There is no way for parent document to know iframe's height, the height is got from actual content (gh-clicks site)
 * @param options
 */
var addBzWidget = function addBzWidget(options) {
  var containerId = options.containerId,
    catId = options.catId,
    source = options.source,
    clickSlug = options.clickSlug,
    thankYou = options.thankYou,
    tracking = options.tracking;
  var palette = options.palette || 'default';
  var random = Math.round(Math.random() * 10000000000000000);
  var internalBuyerZoneContainerId = "internal-bz-widget-" + random;
  var iframeId = "gh-iframe-thank-you-embed-" + containerId + "-" + random;
  var container = document.getElementById(containerId);
  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var loadBuyerZone, response, _ref3, publisherId;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            loadBuyerZone = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(pubId) {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (window.bzWidget) {
                          _context.next = 3;
                          break;
                        }
                        _context.next = 3;
                        return loadScript('//cdn.buyerzone.com/apps/widget/bzWidget.min.js');
                      case 3:
                        container.insertAdjacentHTML('beforeend', "<div id=\"" + internalBuyerZoneContainerId + "\">" + ("<div\n            data-bzwidget\n            data-bzwidget-pub-id=\"" + pubId + "\"\n            data-bzwidget-color-palette-name=\"" + palette + "\"\n            data-bzwidget-keyword-id=\"" + source + "\"\n            data-bzwidget-category-id=\"" + catId + "\"\n         />") + '</div>');
                        _context.next = 6;
                        return window.bzWidget.init();
                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              return function loadBuyerZone(_x) {
                return _ref2.apply(this, arguments);
              };
            }();
            _context2.prev = 1;
            _context2.next = 4;
            return fetch("https://functions.growthhub.com/wizard/lookup-bz-publisher-id?clickSlug=" + clickSlug);
          case 4:
            response = _context2.sent;
            _context2.next = 7;
            return response.json();
          case 7:
            _context2.t0 = _context2.sent;
            if (_context2.t0) {
              _context2.next = 10;
              break;
            }
            _context2.t0 = {};
          case 10:
            _ref3 = _context2.t0;
            publisherId = _ref3.publisherId;
            _context2.next = 14;
            return loadBuyerZone(publisherId || options.pubId);
          case 14:
            _context2.next = 19;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t1 = _context2["catch"](1);
            if (_context2.t1 instanceof Error) console.error('Failed to fetch /lookup-bz-publisher-id', _context2.t1);
          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 16]]);
  }))();
  var onmessageFromBZ = function onmessageFromBZ(_ref4) {
    var origin = _ref4.origin,
      data = _ref4.data;
    var payload = data || {};
    if (origin !== BUYERZONE_APP) return;
    var eventName = payload.eventName;
    switch (eventName) {
      case 'bzConversion':
        // from buyerzone widget
        new ThankYou({
          containerId: containerId,
          iframeId: iframeId,
          clickSlug: clickSlug,
          thankYou: thankYou,
          tracking: tracking
        }).startEmbed();
        break;
    }
  };
  var onmessageFromClick = function onmessageFromClick(_ref5) {
    var origin = _ref5.origin,
      data = _ref5.data;
    var payload = data || {};
    if (origin !== CLICK_APP) return;
    var action = payload.action,
      frameHeight = payload.frameHeight;
    var iframe = document.getElementById(iframeId);
    switch (action) {
      case 'UPDATE_THANK_YOU_HEIGHT':
        // from gh-clicks
        if (!iframe) return;
        iframe.style.height = (frameHeight || 600) + "px";
        break;
    }
  };
  return function (e) {
    onmessageFromBZ(e);
    onmessageFromClick(e);
  };
};

/**
 * This is handling exit popup only when exit popup is enabled and clicks size is more than 0
 */
var ExitPopup = /*#__PURE__*/function () {
  function ExitPopup(options) {
    var random = Math.round(Math.random() * 10000000000000000);
    this.containerId = options.containerId;
    this.wrapperExitPopupId = "gh-wrapper-exit-popup-" + random;
    this.parentExitPopupId = "gh-parent-exit-popup-" + random;
    this.iframeExitPopupId = "gh-iframe-exit-popup-" + random;
    this.exitPopup = options.exitPopup;
    this.tracking = options.tracking;
  }
  /**
   * Register exit popup and add event handlers related to it.
   * Also, it returns onmessage handler related to exit popup to accept events from iframe.
   */
  var _proto = ExitPopup.prototype;
  _proto.register = function register() {
    var _this = this;
    var exitPopup = this.exitPopup;
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var size;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return findClicksSize({
                name: exitPopup
              });
            case 2:
              size = _context.sent;
              if (size > 0) {
                _this.addExitPopup();
                _this.addEventHandlers();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
    return function (e) {
      var origin = e.origin,
        data = e.data;
      var payload = data || {};
      var action = payload.action,
        frameHeight = payload.frameHeight;
      if (origin !== CLICK_APP) return;
      var parentExitPopup = document.getElementById(_this.parentExitPopupId);
      var iframeExitPopup = document.getElementById(_this.iframeExitPopupId);
      var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      switch (action) {
        case 'UPDATE_CLICK_HEIGHT':
          // from gh-clicks
          parentExitPopup.style.marginTop = Math.max(20, windowHeight / 2 - frameHeight / 2) + "px";
          iframeExitPopup.style.height = (frameHeight || 600) + "px";
          break;
      }
    };
  }
  /**
   * This function is adding a new exit popup to container.
   * @private
   */;
  _proto.addExitPopup = function addExitPopup() {
    var containerId = this.containerId,
      wrapperExitPopupId = this.wrapperExitPopupId,
      parentExitPopupId = this.parentExitPopupId,
      iframeExitPopupId = this.iframeExitPopupId,
      exitPopup = this.exitPopup,
      tracking = this.tracking;
    var container = document.getElementById(containerId);
    if (!container) return;
    container.insertAdjacentHTML('beforeend', "<div\n                id=\"" + wrapperExitPopupId + "\"\n                style=\"position: fixed; height: 100%; inset: 0; z-index: 1300; background: rgba(0, 0, 0, 0.7);\n                       transition: transform 0s; transform: translateY(500%) scale(0.001);\"\n            >" + ("<div\n                id=\"" + parentExitPopupId + "\"\n                style=\"position: relative; width: 80%; background-color: white; padding: 13px 19px; margin: 20px auto;\"\n               >") + ("<img\n                 src=\"" + CLICK_APP + "/static/x-button.png\"\n                 style=\"width: 30px; height: 30px; position: absolute; right: -15px; top: -15px; cursor: pointer;\"\n                 alt=\"Close button\"\n               />") + ("<iframe\n                 id=\"" + iframeExitPopupId + "\"\n                 src=\"" + CLICK_APP + "?name=" + exitPopup + "&fcw=" + encodeURIComponent(tracking.clientRoute) + "&referer=" + encodeURIComponent(tracking.referer) + "\"\n                 style=\"border: none; width: 100%; height: 100%; max-height: 800px;\"></iframe>") + '</div>' + '</div>');
  }
  /**
   * This function adds event handlers for the exit popup previously added.
   * @private
   */;
  _proto.addEventHandlers = function addEventHandlers() {
    var parentExitPopupId = this.parentExitPopupId,
      wrapperExitPopupId = this.wrapperExitPopupId;
    var wrapperExitPopup = document.getElementById(wrapperExitPopupId);
    if (!wrapperExitPopup) return;
    var inactivityTimeout;
    var opened = false;
    var mobile = false;
    var smallMedium = function smallMedium(media) {
      var parentExitPopup = document.getElementById(parentExitPopupId);
      if (media.matches) {
        parentExitPopup.style.width = '440px';
        mobile = false;
      } else {
        parentExitPopup.style.width = '80%';
        mobile = true;
      }
    };
    var mouseoutEvent = function mouseoutEvent(e) {
      var shouldShowExitIntent = !opened && !e.toElement && !e.relatedTarget && e.clientY < 30;
      if (shouldShowExitIntent) {
        if (inactivityTimeout) clearTimeout(inactivityTimeout);
        document.removeEventListener('mouseout', mouseoutEvent);
        wrapperExitPopup.style.transform = 'translateY(0) scale(1)';
        opened = true;
      }
    };
    var inactivityCheckEvent = function inactivityCheckEvent() {
      if (!opened) {
        if (inactivityTimeout) clearTimeout(inactivityTimeout);
        inactivityTimeout = setTimeout(function () {
          document.removeEventListener('mouseover', inactivityCheckEvent);
          document.removeEventListener('click', inactivityCheckEvent);
          document.removeEventListener('scroll', inactivityCheckEvent);
          wrapperExitPopup.style.transform = 'translateY(0) scale(1)';
          opened = true;
        }, 10000);
      }
    };
    var mobileScrollEvent = function mobileScrollEvent() {
      if (!opened && mobile) {
        var BOTTOM_MARGIN = 100;
        // References: https://stackoverflow.com/questions/9439725/javascript-how-to-detect-if-browser-window-is-scrolled-to-bottom
        if (window.innerHeight + window.scrollY + BOTTOM_MARGIN >= document.body.offsetHeight) {
          if (inactivityTimeout) clearTimeout(inactivityTimeout);
          document.removeEventListener('scroll', mobileScrollEvent);
          wrapperExitPopup.style.transform = 'translateY(0) scale(1)';
          opened = true;
        }
      }
    };
    var media = window.matchMedia('(min-width: 640px)');
    var image = document.querySelector("#" + parentExitPopupId + " img");
    smallMedium(media);
    inactivityCheckEvent();
    media.addEventListener('change', smallMedium);
    image.addEventListener('click', function () {
      wrapperExitPopup.style.transform = 'translateY(500%) scale(0.001)';
    });
    document.addEventListener('mouseout', mouseoutEvent);
    document.addEventListener('mouseover', inactivityCheckEvent);
    document.addEventListener('click', inactivityCheckEvent);
    document.addEventListener('scroll', inactivityCheckEvent);
    document.addEventListener('scroll', mobileScrollEvent);
  };
  return ExitPopup;
}();

/**
 * This is class to fire divolte and ads events such as google ads, bing ads, and facebook ads.
 * The events are fired in two use cases.
 * The one is fired when user completes first interaction from lead form (ex - choose first combobox).
 * The another is fired when user complete lead form.
 * Divolte event will be fired only for bz widget at this moment.
 */
var AdTracking = /*#__PURE__*/function () {
  function AdTracking(options) {
    this.analytics = options.analytics;
    this.payload = options.payload;
    this.eventName = options.payload.eventName;
  }
  AdTracking.register = function register(_ref) {
    var analytics = _ref.analytics;
    return function (e) {
      var origin = e.origin;
      var payload = e.data || {};
      var eventName = payload.eventName;
      var originAllowed = origin === BUYERZONE_APP || origin === WIZARD_APP;
      var ghEventAllowed = eventName === 'ghFirstInteraction' || eventName === 'ghLead';
      var allowed = originAllowed && (origin === WIZARD_APP ? ghEventAllowed : true);
      if (allowed) new AdTracking({
        analytics: analytics,
        payload: payload
      }).fireEvents();
    };
  };
  var _proto = AdTracking.prototype;
  _proto.fireEvents = function fireEvents() {
    switch (this.eventName) {
      case 'bzFirstInteraction':
        this.publishDivolteEvent('BuyerZoneFirstInteraction');
        this.initiateCheckout();
        break;
      case 'ghFirstInteraction':
        this.initiateCheckout();
        break;
      case 'bzConversion':
        this.publishDivolteEvent('BuyerZoneLeadSubmission');
        this.leadGenerated();
        break;
      case 'ghLead':
        this.leadGenerated();
        break;
    }
  };
  _proto.initiateCheckout = function initiateCheckout() {
    AdTracking.snapchatAd({
      action: 'START_CHECKOUT'
    });
    AdTracking.quoraAd({
      action: 'Generic'
    });
    AdTracking.tiktokAd({
      action: 'InitiateCheckout'
    });
    AdTracking.facebookAd({
      action: 'InitiateCheckout'
    });
    AdTracking.bingAds({
      action: this.eventName
    });
    this.geminiAd({
      action: 'bzLead',
      conversionDisabled: true
    }); // Currently, only bzLead action exists. Later, we'll introduce ghLead action event.
    this.redditAd({
      action: 'Lead',
      conversionDisabled: true
    });
    this.googleAds({
      action: this.eventName,
      lead: false
    });
  };
  _proto.leadGenerated = function leadGenerated() {
    var action = {
      bzConversion: 'bzLead',
      ghLead: 'ghLead'
    }[this.eventName];
    AdTracking.snapchatAd({
      action: 'SIGN_UP'
    });
    AdTracking.quoraAd({
      action: 'Generic'
    });
    AdTracking.tiktokAd({
      action: 'SubmitForm'
    });
    AdTracking.facebookAd({
      action: 'Lead'
    });
    AdTracking.bingAds({
      action: action
    });
    this.geminiAd({
      action: 'bzLead'
    }); // Currently, only bzLead action exists. Later, we'll introduce ghLead action event.
    this.redditAd({
      action: 'Lead'
    });
    this.googleAds({
      action: action,
      lead: true
    });
  };
  _proto.publishDivolteEvent = function publishDivolteEvent(actionName) {
    if (!window.divolte) return;
    window.divolte.signal('ClickHappened', {
      actionType: actionName,
      actionPayload: JSON.stringify(this.payload || {})
    });
  };
  _proto.geminiAd = function geminiAd(_ref2) {
    var _this$analytics;
    var action = _ref2.action,
      conversionDisabled = _ref2.conversionDisabled;
    if (!((_this$analytics = this.analytics) != null && _this$analytics.gemini)) return;
    var _this$analytics2 = this.analytics,
      gemini = _this$analytics2.gemini,
      costPerLead = _this$analytics2.costPerLead;
    var conversionAllowed = !conversionDisabled && typeof costPerLead === 'number';
    if (window.location.href && window.location.href.indexOf('mode=debug') !== -1) {
      console.log({
        gemini: gemini,
        costPerLead: costPerLead,
        conversionDisabled: conversionDisabled,
        conversionAllowed: conversionAllowed
      });
    }
    window.dotq = window.dotq || [];
    window.dotq.push({
      projectId: gemini.projectId,
      properties: {
        pixelId: gemini.pixelId,
        qstrings: _extends({
          et: 'custom',
          ec: 'Lead',
          ea: action,
          el: action
        }, conversionAllowed ? {
          gv: costPerLead
        } : {})
      }
    });
  };
  AdTracking.quoraAd = function quoraAd(_ref3) {
    var action = _ref3.action;
    if (!window.qp) return;
    console.log('Quora ads exists!');
    window.qp('track', action);
  };
  _proto.redditAd = function redditAd(_ref4) {
    var _this$analytics3, _this$analytics4;
    var action = _ref4.action,
      conversionDisabled = _ref4.conversionDisabled;
    if (!window.rdt) return;
    console.log('Reddit ads exists!');
    var conversionAllowed = !conversionDisabled && typeof ((_this$analytics3 = this.analytics) == null ? void 0 : _this$analytics3.costPerLead) === 'number';
    if (conversionAllowed) window.rdt('track', action, {
      currency: 'USD',
      value: (_this$analytics4 = this.analytics) == null ? void 0 : _this$analytics4.costPerLead
    });else window.rdt('track', action);
  };
  AdTracking.snapchatAd = function snapchatAd(_ref5) {
    var action = _ref5.action;
    if (!window.snaptr) return;
    console.log('Snapchat ads exists!');
    window.snaptr('track', action);
  };
  AdTracking.tiktokAd = function tiktokAd(_ref6) {
    var action = _ref6.action;
    if (!window.ttq) return;
    console.log('Tiktok ads exists!');
    window.ttq.track(action);
  };
  AdTracking.facebookAd = function facebookAd(_ref7) {
    var action = _ref7.action;
    if (!window.fbq) return;
    console.log('Facebook ads exists!');
    window.fbq('track', action);
  };
  AdTracking.bingAds = function bingAds(_ref8) {
    var action = _ref8.action;
    window.uetq = window.uetq || [];
    window.uetq.push('event', action, {});
  };
  _proto.googleAds = function googleAds(_ref9) {
    var _this$analytics5;
    var action = _ref9.action,
      lead = _ref9.lead;
    if (!((_this$analytics5 = this.analytics) != null && _this$analytics5.googleAds)) return;
    var _this$analytics$googl = this.analytics.googleAds,
      conversionId = _this$analytics$googl.conversionId,
      firstInteractionConversionLabel = _this$analytics$googl.firstInteractionConversionLabel,
      leadConversionLabel = _this$analytics$googl.leadConversionLabel;
    var sentTo = conversionId + "/" + (lead ? leadConversionLabel : firstInteractionConversionLabel);
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    }
    function callback() {
      console.log(action + " event action was sent successfully!");
    }
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    gtag('js', new Date());
    // @ts-ignore
    gtag('config', conversionId);
    // @ts-ignore
    gtag('event', action, {
      send_to: sentTo,
      event_callback: callback
    });
  };
  return AdTracking;
}();

/**
 * This function adds a mvf widget. Also, it returns onmessage handler to accept events from its iframe.
 * @param options
 */
var addMvfWidget = function addMvfWidget(options) {
  var containerId = options.containerId,
    domain = options.domain,
    formId = options.formId,
    campaignId = options.campaignId,
    themeName = options.themeName,
    borderEnabled = options.borderEnabled,
    eventHandlers = options.eventHandlers,
    widgetLabel = options.widgetLabel;
  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _window;
    var iframe;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (window.runFormWidgetLoader) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return loadScript('//chameleon-frontend-ca.mvfglobal.com/formLoader.min.js');
          case 3:
            (_window = window) == null ? void 0 : _window.runFormWidgetLoader(_extends({
              containerId: containerId,
              domain: domain,
              formId: formId,
              campaignId: campaignId,
              themeName: themeName,
              borderEnabled: !!borderEnabled
            }, eventHandlers ? {
              eventHandlers: eventHandlers
            } : {}, widgetLabel ? {
              widgetLabel: widgetLabel
            } : {}));
            iframe = document.querySelector("#" + containerId + " iframe");
            if (iframe) iframe.style.maxWidth = '920px'; // from 800px which mvf widget generated
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();
};

var SubIdTypes = {
  gclid: 'Google',
  msclkid: 'Microsoft',
  fbclid: 'Facebook',
  ttclid: 'Tiktok',
  tid: 'Tonic',
  gbraid: 'Google',
  wbraid: 'Google',
  cid: 'ZeroPark',
  rdt_cid: 'Reddit',
  qclid: 'Quora',
  yclid: 'Gemini'
};
var MAX_CHUNK = 5;
var CHUNK_SIZE = 50;
var REGEX_SUB_ID_CHUNKS = /\{subIdChunk[0-9]\}/g;
var REGEX_SUB_ID_TYPE = /\{subIdType\}/g;
var REGEX_SUB_ID = /\{subId\}/g;
var REGEX_WEBSITE_HASH = /\{website_hash\}/g;
var REGEX_DOUBLE_BARS = /\|\|/g;
var findSubIdChunk = function findSubIdChunk(num) {
  return new RegExp("{subIdChunk" + num + "}", 'g');
};
var findTracking = function findTracking(clientRoute) {
  var _extractDomain, _ref, _query$fcw;
  var _queryString$parseUrl = queryString.parseUrl(clientRoute != null ? clientRoute : ''),
    query = _queryString$parseUrl.query;
  var resolvedUrlQuery = query;
  if (query != null && query.fcw) {
    var fcw = resolvedUrlQuery.fcw;
    var _queryString$parseUrl2 = queryString.parseUrl(fcw != null ? fcw : ''),
      queryFromFcw = _queryString$parseUrl2.query;
    resolvedUrlQuery = _extends({}, resolvedUrlQuery, queryFromFcw);
  }
  var subIdType = Object.keys(SubIdTypes).find(function (subIdTypeTemp) {
    return resolvedUrlQuery[subIdTypeTemp];
  });
  var response = {};
  if (subIdType) response = _extends({}, response, {
    subIdType: subIdType,
    subId: resolvedUrlQuery[subIdType]
  });
  var website = (_extractDomain = extractDomain((_ref = (_query$fcw = query == null ? void 0 : query.fcw) != null ? _query$fcw : clientRoute) != null ? _ref : '')) == null ? void 0 : _extractDomain.toLowerCase();
  var websiteHash = Md5.hashStr(website);
  return _extends({}, response, {
    website: website,
    websiteHash: websiteHash
  });
};
var generateUrlWithTracking = function generateUrlWithTracking(_ref2) {
  var finalUrl = _ref2.finalUrl,
    clientRoute = _ref2.clientRoute,
    placeholder = _ref2.placeholder;
  if (!finalUrl) return finalUrl;
  if (!placeholder) return finalUrl;
  var _findTracking = findTracking(clientRoute),
    subIdType = _findTracking.subIdType,
    subId = _findTracking.subId,
    websiteHash = _findTracking.websiteHash;
  if (!subIdType || !subId) {
    if (!REGEX_DOUBLE_BARS.test(placeholder)) return finalUrl;
    var parts = placeholder.split(REGEX_DOUBLE_BARS);
    var _queryString$parseUrl3 = queryString.parseUrl(finalUrl),
      _url = _queryString$parseUrl3.url,
      _productUrlQuery = _queryString$parseUrl3.query;
    return queryString.stringifyUrl({
      url: _url,
      query: _extends({}, queryString.parse(parts[1]), _productUrlQuery)
    });
  }
  var placeholderBound = placeholder.replace(REGEX_SUB_ID_TYPE, subIdType).replace(REGEX_SUB_ID, subId).replace(REGEX_WEBSITE_HASH, websiteHash).replace(REGEX_DOUBLE_BARS, '&');
  if (REGEX_SUB_ID_CHUNKS.test(placeholderBound)) {
    for (var i = 0; i <= MAX_CHUNK; i += 1) {
      var regex = findSubIdChunk(i + 1);
      var matched = regex.test(placeholderBound);
      if (matched) {
        placeholderBound = placeholderBound.replace(regex, subId.substring(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
      }
    }
  }
  var placeholderQuery = queryString.parse(placeholderBound);
  var _queryString$parseUrl4 = queryString.parseUrl(finalUrl),
    url = _queryString$parseUrl4.url,
    productUrlQuery = _queryString$parseUrl4.query;
  return queryString.stringifyUrl({
    url: url,
    query: _extends({}, placeholderQuery, productUrlQuery)
  });
};
var addHttpsIfNone = function addHttpsIfNone(url) {
  var lowercase = url.toLowerCase();
  if (lowercase.startsWith('https://') || lowercase.startsWith('http://')) {
    return url;
  }
  return "https://" + url;
};

/**
 * This is function to initialize a widget among gh wizard, bz widget, and mvf widget
 * @param initialOptions
 */
var initWidget = function initWidget(initialOptions) {
  var _clickLists$find, _clickLists$find2;
  var verticalName = initialOptions.verticalName;
  var options = initialOptions;
  options.clickSlug = options.clickSlug || (verticalName ? verticalName.replace(/_/g, '-') : undefined);
  var type = options.type,
    topContainerId = options.containerId,
    clickSlug = options.clickSlug,
    analytics = options.analytics,
    widgets = options.widgets,
    clickLists = options.clickLists;
  var exitPopup = clickLists == null ? void 0 : (_clickLists$find = clickLists.find(function (clickList) {
    return clickList.type === 'exitPopup';
  })) == null ? void 0 : _clickLists$find.name;
  var thankYou = clickLists == null ? void 0 : (_clickLists$find2 = clickLists.find(function (clickList) {
    return clickList.type === 'thankYou';
  })) == null ? void 0 : _clickLists$find2.name;
  var tracking = {
    clientRoute: window.location.href,
    referer: document.referrer,
    search: window.location.search
  };
  var topContainer = document.getElementById(topContainerId);
  if (!topContainer) {
    window.alert('[containerId] is required field.');
    return;
  }
  var random = Math.round(Math.random() * 10000000000000000);
  var containerId = topContainerId + "-" + random;
  topContainer.style.minHeight = 'max-content';
  topContainer.style.marginBottom = '-4px';
  topContainer.innerHTML = "<div id=\"" + containerId + "\" />";
  var widget = widgets.find(function (o) {
    return o.type === type;
  });
  if (!widget) {
    window.alert('[widgets] is required field.');
    return;
  }
  var onmessageGhWizard;
  var onmessageBzWidget;
  var onmessageExitPopup;
  var _findTracking = findTracking(tracking.clientRoute),
    subId = _findTracking.subId;
  switch (type) {
    case 'growthHub':
      onmessageGhWizard = addGhWizard(_extends({
        containerId: containerId,
        tracking: tracking
      }, widget));
      break;
    case 'buyerZone':
      onmessageBzWidget = addBzWidget(_extends({
        containerId: containerId,
        clickSlug: clickSlug,
        thankYou: thankYou,
        tracking: tracking
      }, widget));
      break;
    case 'mvf':
      addMvfWidget(_extends({
        containerId: containerId,
        widgetLabel: subId
      }, widget));
      break;
    default:
      window.alert('[type] is required field.');
      return;
  }
  if (exitPopup) {
    onmessageExitPopup = new ExitPopup({
      containerId: containerId,
      exitPopup: exitPopup,
      tracking: tracking
    }).register();
  }
  var onmessageAdTracking = AdTracking.register({
    analytics: analytics
  });
  window.onmessage = function (e) {
    onmessageAdTracking(e);
    if (onmessageGhWizard) onmessageGhWizard(e);
    if (onmessageBzWidget) onmessageBzWidget(e);
    if (onmessageExitPopup) onmessageExitPopup(e);
  };
};

var Theme = {
  BLUE_ORANGE: {
    primary: {
      light: '#63b1ff',
      main: '#1482d6',
      dark: '#0056a4',
      contrastText: '#fff'
    },
    secondary: {
      light: '#ffa552',
      main: '#f47421',
      dark: '#bb4500',
      contrastText: '#fff'
    }
  }
};

function S1Search(_ref) {
  var domain = _ref.domain,
    partnerId = _ref.partnerId,
    gdprOptIn = _ref.gdprOptIn,
    isTest = _ref.isTest,
    q = _ref.q,
    segment = _ref.segment,
    signature = _ref.signature,
    subId = _ref.subId,
    subIdType = _ref.subIdType,
    device = _ref.device,
    bfcid = _ref.bfcid,
    bfkid = _ref.bfkid,
    semwsEndpoint = _ref.semwsEndpoint;
  // eslint-disable-next-line max-len
  var clickTrackingUrl = semwsEndpoint + "/s1?domain={info[domain]}&query={info[query]}&segment={info[segment]}&ip={requestu_args[ip]}&gclid={info[persist_args][gclid]}&msclkid={info[persist_args][msclkid]}&p={extra_args[p]}&position={extra_args[position]}&advertiser_domain={extra_args[advertiser_domain]}&device=" + device + "&bfcid=" + bfcid + "&subId=" + subId + "&subIdType=" + subIdType + "&bfkid=" + bfkid;
  return React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "\n        bootstrap();\n        \n        function bootstrap() {\n          var REQUIRED_REGIONS = [ 'mainline-top', 'mainline-algo', 'mainline-bottom', 'mainline-aylf', 'sidebar', 'pagination' ];\n          var allExisted = true;\n          for (var region of REQUIRED_REGIONS) {\n            var el = document.querySelector('div[data-s1search=' + region + ']');\n            if (!el) {\n              allExisted = false;\n              break;\n            }\n          }\n          \n          if (allExisted) {\n            console.log('All regions exist!');\n            return loadS1Search();\n          }\n          setTimeout(bootstrap, 250);\n        }\n        function loadS1Search() {\n          window.s1search = window.s1search || function () { (window.s1search.q = window.s1search.q || []).push(arguments) };\n          window.s1search('config', {\n            category: \"web\",\n            domain: \"" + domain + "\",\n            partnerId: " + partnerId + ",\n            gdprOptIn: " + gdprOptIn + ",\n            isTest: " + isTest + ",\n            onComplete: onResolved,\n            onError: onRejected,\n            query: \"" + q + "\",\n            querystringParams: {\"page\": \"page\", \"query\": \"q\"},\n            segment: \"" + segment + "\",\n            signature: \"" + signature + "\",\n            subId: \"" + bfcid + "\", // subId system1 thinks is bfcid vs msclkid or gclid\n            bfcid: \"" + bfcid + "\", // bfcid is custom parameter for bluefin\n            bfkid: \"" + bfkid + "\",\n            clickTrackingUrl: \"" + clickTrackingUrl + "\"\n          });\n        }\n        function onResolved() {\n          console.log('completed');\n        }\n        function onRejected(msg) {\n          console.log('error: ', msg);\n          console.error(msg);\n          window.Sentry.captureException(msg);\n        }\n      "
    }
  });
}

export { AdsDisclaimer, BUYERZONE_APP, CLICK_APP, CookieBanner, Markdown, MarkdownPath, S1Search, Seo, Theme, WIZARD_APP, addHttpsIfNone, findTracking, generateUrlWithTracking, initWidget, renderMarkdown };
//# sourceMappingURL=bluefin-libs.esm.js.map
